import React, { useEffect } from 'react';
import {
  withStyles,
  Theme,
  createStyles,
  makeStyles,
} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import { IAuthContext } from '../../context/auth/auth-context';
import withAuthContext from '../../context/auth/AuthConsumer';
// import Paginations from './Pagination';
import styled from 'styled-components';
import { OverlayTrigger, Pagination } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const TableWrapper = styled.div`
  .container {
    overflow: auto;
    height: 100vh;
    padding: 0;
    max-width: unset;
    background: transparent;
    border: 1px solid rgba(148, 163, 184, 0.2);

    table {
      width: 100%;
      background: transparent;
      border-collapse: collapse;
    }
  }

  .MuiPaper-root {
    background: transparent !important;
    box-shadow: none !important;
  }

  .MuiTableHead-root .MuiTableRow-root {
    background: rgba(15, 23, 42, 0.9);
  }

  .MuiTableBody-root .MuiTableRow-root {
    background: rgba(15, 23, 42, 0.45);
  }

  .MuiTableBody-root .MuiTableRow-root:hover {
    background: rgba(15, 23, 42, 0.62);
  }

  .MuiTableBody-root .MuiTableCell-root {
    color: #dbe3ef !important;
    background: rgba(15, 23, 42, 0.45) !important;
    border-color: rgba(148, 163, 184, 0.2) !important;
    border-right: 1px solid rgba(148, 163, 184, 0.2);
    font-family: var(--sans, 'DM Sans', -apple-system, sans-serif) !important;
    font-size: 14px !important;
    line-height: 1.35;
    vertical-align: top;
  }

  .MuiTableBody-root .MuiTableCell-root a {
    color: #34d399;
    font-weight: 500;
  }

  .MuiTableBody-root .MuiTableCell-root a:hover {
    color: #6ee7b7;
  }
`;

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      '&.MuiTableCell-head': {
        backgroundColor: 'rgba(15, 23, 42, 0.9)',
        color: '#f8fafc',
        borderColor: 'rgba(148, 163, 184, 0.25)',
        borderRight: '1px solid rgba(148, 163, 184, 0.25)',
        fontSize: '15px',
        fontWeight: 600,
        fontFamily: 'var(--sans, "DM Sans", -apple-system, sans-serif)',
        textAlign: 'center',
      },
      '& .MuiTableSortLabel-root:hover': {
        color: '#f8fafc',
      },
      '& .MuiTableSortLabel-icon': {
        color: '#f8fafc !important',
      },
      '& .MuiTableSortLabel-root:focus': {
        color: '#f8fafc',
      },
      '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
        color: '#f8fafc',
      },
    },
    body: {
      fontSize: 14,
      color: '#dbe3ef',
      backgroundColor: 'rgba(15, 23, 42, 0.45)',
      borderColor: 'rgba(148, 163, 184, 0.2)',
      borderRight: '1px solid rgba(148, 163, 184, 0.2)',
      fontFamily: 'var(--sans, "DM Sans", -apple-system, sans-serif)',
      lineHeight: 1.35,
      verticalAlign: 'top',
    },
  })
)(TableCell);

const CustTableCell = styled(TableCell)`
  em {
    font-style: normal;
    font-weight: 700;
  }
`;

const TableCellFont = styled.div`
  font-size: 15px;
  font-weight: 600;
  font-family: var(--sans, 'DM Sans', -apple-system, sans-serif);
`;

const PageNumbersContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 1em 0;

  .pagination {
    margin: 0;
  }

  .page-link {
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
    padding: 0.5rem 0.75rem;
    margin: 0 2px;
    border-radius: 0.25rem;
    cursor: pointer;

    &:hover {
      color: #0056b3;
      background-color: #e9ecef;
      border-color: #dee2e6;
    }

    &.active {
      background-color: #007bff;
      border-color: #007bff;
      color: white;
    }

    &:disabled {
      color: #6c757d;
      pointer-events: none;
      background-color: #fff;
      border-color: #dee2e6;
    }
  }
`;

interface INotificationContainerProps {
  notifications: any[];
  getSubjectTrack: any;
  showItems: number;
  isLoad: boolean;
  orderDate: any;
  setLoad: any;
  setOrderDate: any;
  setOrderKeyword: any;
  activeOrder: string;
  setActiveOrder: any;
  orderKeyword: any;
  rows: any;
  setShowFrom: any;
  showFrom: any;
  getSubscriptionList: any;
}

const NotificationContainer: React.FC<
  INotificationContainerProps & { context: IAuthContext }
> = (props) => {
  const {
    getSubjectTrack,
    showItems,
    isLoad,
    orderDate,
    setLoad,
    setOrderDate,
    setOrderKeyword,
    orderKeyword,
    rows,
    setShowFrom,
    showFrom,
    getSubscriptionList,
    activeOrder,
    setActiveOrder,
  } = props;
  const classes = useStyles();

  // const onPreviousClick = async () => {
  //   setShowFrom(showFrom - showItems);
  //   getSubjectTrack(showFrom - showItems);
  // };
  // const onNextClick = async () => {
  //   setShowFrom(showFrom + showItems);
  //   getSubjectTrack(showFrom + showItems);
  // };

  const onPageClick = async (pageNumber: number) => {
    const newShowFrom = (pageNumber - 1) * showItems;
    setShowFrom(newShowFrom);
    getSubjectTrack(newShowFrom);
  };

  const currentPage = rows && rows.total_records > 0 ? Math.floor(showFrom / showItems) + 1 : 1;
  const totalPages = rows && rows.total_records > 0 ? Math.ceil(rows.total_records / showItems) : 1;

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
      const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

      if (endPage - startPage + 1 < maxVisiblePages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }

    return pages;
  };

  useEffect(() => {
    if (isLoad) {
      getSubjectTrack();
      getSubscriptionList();
    }
  });

  return (
    <>
      <TableWrapper>
        <TableContainer component={Paper} className="container">
          <Table className={classes.table} aria-label=" table">
            <TableHead>
              <TableRow>
                <StyledTableCell align="center" className="cmn-w-10">
                  <TableSortLabel
                    active={activeOrder === 'date' ? true : false}
                    direction={orderDate}
                    onClick={() => {
                      setOrderDate(orderDate === 'asc' ? 'desc' : 'asc');
                      setOrderKeyword('asc');
                      setLoad(true);
                      setActiveOrder('date');
                    }}
                  >
                    Date/Time Generated
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell className="cmn-w-13">
                  <TableSortLabel
                    active={activeOrder === 'keyword' ? true : false}
                    direction={orderKeyword}
                    onClick={() => {
                      setOrderKeyword(orderKeyword === 'asc' ? 'desc' : 'asc');
                      setOrderDate('desc');
                      setLoad(true);
                      setActiveOrder('keyword');
                    }}
                  >
                    Words/Subjects Tracked
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <TableCellFont>Snippet</TableCellFont>
                </StyledTableCell>
                <StyledTableCell className="cmn-w-14">
                  Entity Name
                </StyledTableCell>
                <StyledTableCell align="center">Documents</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.data &&
                rows.data.length > 0 &&
                rows.data.map((row: any, index: number) => (
                  <TableRow key={row.document_id + index}>
                    <TableCell component="th" scope="row" align="center">
                      {row.document_date}
                    </TableCell>
                    <TableCell>{row.keyword}</TableCell>
                    <CustTableCell
                      className="cmn-word-break"
                      dangerouslySetInnerHTML={{
                        /*eslint no-control-regex: 0*/
                        __html: row.document_snippet.replace(/[^\x00-\x7F]/g, ''),
                      }}
                    />

                    <TableCell>{row.document_entity_name}</TableCell>
                    <TableCell>
                    <OverlayTrigger
                          placement="bottom"
                          key={index}
                          overlay={<ReactTooltip effect="solid" />}
                        >
                      <a
                      data-tip="Click to download"
                        href={row.document_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {row.document_source}
                      </a>
                      </OverlayTrigger>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </TableWrapper>

      {rows && rows.total_records > 0 && (
        <PageNumbersContainer>
          <Pagination size="lg">
            <Pagination.First
              disabled={currentPage === 1}
              onClick={() => onPageClick(1)}
            />
            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => onPageClick(currentPage - 1)}
            />
            {getPageNumbers().map((pageNum) => (
              <Pagination.Item
                key={pageNum}
                active={pageNum === currentPage}
                onClick={() => onPageClick(pageNum)}
              >
                {pageNum}
              </Pagination.Item>
            ))}

            <Pagination.Next
              disabled={currentPage === totalPages}
              onClick={() => onPageClick(currentPage + 1)}
            />
            <Pagination.Last
              disabled={currentPage === totalPages}
              onClick={() => onPageClick(totalPages)}
            />
          </Pagination>
        </PageNumbersContainer>
      )}
      {/* <Paginations
        isDisabled={false}
        isFirstPage={(rows && rows.records_num_from === 0) || false}
        isLastPage={
          (rows &&
            rows.records_num_from + rows.records_num_show >=
              rows.total_records) ||
          false
        }
        totalRecords={(rows && rows.total_records) || 0}
        onPreviousClick={onPreviousClick}
        onNextClick={onNextClick}
      /> */}
    </>
  );
};
export default withAuthContext(NotificationContainer);
